import { render } from "./UploadPostMedia.vue?vue&type=template&id=dee71e12&scoped=true"
import script from "./UploadPostMedia.vue?vue&type=script&lang=js"
export * from "./UploadPostMedia.vue?vue&type=script&lang=js"

import "./UploadPostMedia.vue?vue&type=style&index=0&id=dee71e12&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dee71e12"]])

export default __exports__